import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Chip
} from '@mui/material'

import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import BadgeIcon from '@mui/icons-material/Badge';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ContactsIcon from '@mui/icons-material/Contacts';
import EmailIcon from '@mui/icons-material/Email';

const ShopContactInfo = ({current}) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif'
      }


    return(
        <>
        <hr/>
            <List className='contactInfocard'>

       
                <ListItem >
                    <ListItemAvatar>
                        <Avatar><StorefrontIcon/></Avatar>
                    </ListItemAvatar>
                    

                 <ListItemText style={listStyles} primary="STORE ID:" secondary={current.shopId} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PersonIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="OWNER NAME" secondary={current.userName} />
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><BadgeIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="USER ID" secondary={current.userId} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactPhoneIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="PHONE NO" secondary={current.phNo} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                

                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PauseCircleOutlineIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="STORE STATUS:" secondary={current.status} />
                </ListItem>

                
            


                <div>   

                { current.contList.length>0 ?
                    <div className='mt-3 content'>

                { current.contList.map(item=>(
                                            
                           <div>
                <Divider variant='inset' component="li"/>
                 <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactsIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="MOBILE NO:" secondary={item.mobileNo} />
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><EmailIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="EMAIL ID:" secondary={item.email} />
                </ListItem>
                            </div>                 
                               
                     
                                        
                                            
                                            ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 

               
            </List>
           

        </>
    )
}

export default ShopContactInfo